module.exports = __webpack_public_path__ + "img/bc_logo.5869e6e4.svg";